import { useState, useEffect, useMemo } from 'react';
import { NavLink, useHistory } from 'react-router-dom';

import http from '../../services/http';

import Logo from 'utils/Logo';
import { temPermissao } from "../../utils/PermissionGate";
import { filtrarMenus } from 'utils/buscaMenu';
import BuscaMenu, { Destacado } from './BuscaMenu';

const ORDEM_GRUPOS = ['GESTÃO', 'FINANCEIRO', 'LOTERIA', 'CATEGORIAS', 'ESPORTIVAS', 'ADMINISTRAÇÃO'];

function BarraLateral({ user }) {
	const history = useHistory();
	const [rotas, setRotas] = useState([]);
	const [bancaModulos, setBancaModulos] = useState(null);
	const [busca, setBusca] = useState('');

	useEffect(() => {
		const importarRotas = async () => {
			import(`routes/admin/links`).then((links) =>
				setRotas(links.default)
			);
		};

		importarRotas();

		http.get('/bancas/modulos')
			.then(r => {
				const ativos = r.data.data
					.filter(m => m.status === 1)
					.map(m => m.nome);
				setBancaModulos(ativos);
			})
			.catch(() => setBancaModulos([]));
	}, []);

	// Menus que o usuário pode ver, já na ordem dos grupos. A permissão é checada
	// aqui, e não com um PermissionGate por item, para a busca saber o que sobrou
	// (mostrar "nenhum encontrado" e abrir o primeiro resultado no Enter).
	const visiveis = useMemo(() => {
		const nivel = localStorage.getItem('nivel');
		// `user` chega vazio até o /perfil responder; enquanto isso vale o que está
		// gravado, que é o que o PermissionGate lê.
		const usuario = user?.permissoes ? user : (JSON.parse(localStorage.getItem('usuario')) || {});
		const acesso = { permissoes: usuario.permissoes || [], modulos: usuario.modulos || [] };

		return rotas
			.filter(rota => rota.showBar)
			.filter(rota => {
				if (bancaModulos !== null && rota.module && rota.module.length > 0) {
					return rota.module.some(m => bancaModulos.includes(m));
				}
				return true;
			})
			.filter(rota => (rota.nivel ? rota.nivel.includes(nivel) : temPermissao(rota, acesso)))
			.sort((a, b) => {
				const ia = ORDEM_GRUPOS.indexOf(a.group ?? '');
				const ib = ORDEM_GRUPOS.indexOf(b.group ?? '');
				return (ia === -1 ? 99 : ia) - (ib === -1 ? 99 : ib);
			});
	}, [rotas, bancaModulos, user]);

	const resultado = useMemo(() => filtrarMenus(visiveis, busca), [visiveis, busca]);

	const abrirPrimeiro = () => {
		if (resultado.length === 0) return;

		history.push(resultado[0].rota.path);
		setBusca('');
	};

	const fazerLogout = async (e) => {
		e.preventDefault();

		await http.post('/logout');

		localStorage.setItem('token', '');
		localStorage.setItem('nivel', '');
		localStorage.setItem('usuario', '');
		localStorage.setItem('banca', '');
		window.location = '/login';
	};

	let lastGroup = null;
	const items = [];

	resultado.forEach(({ rota, trechos }) => {
		if (rota.group && rota.group !== lastGroup) {
			lastGroup = rota.group;
			items.push(
				<li key={`group-${rota.group}`} className="menu-group-header">
					<span>{rota.group}</span>
				</li>
			);
		}

		items.push(
			<li className="menu-home" key={rota.path}>
				<NavLink exact to={`${rota.path}`} title={rota.nome}>
					<i className={`fa ${rota.icon}`}>
						<span className="menu-title bold">
							<Destacado texto={rota.nome} trechos={trechos} />
						</span>
					</i>
				</NavLink>
			</li>
		);
	});

	return (
		<div className="sidebar-menu">
			{user.logotipo !== null && (
				<div className="logo-sideBar">
					<Logo />
				</div>
			)}
			<BuscaMenu valor={busca} aoMudar={setBusca} aoConfirmar={abrirPrimeiro} />
			<div className="menu">
				<ul id="menu">
					{items}
					{/* Na busca os itens filtrados saem do DOM e a barra encolheria a cada
					    tecla; estes fantasmas (sem altura, invisíveis) mantêm a largura
					    do maior nome do menu */}
					{busca && visiveis.map((rota) => (
						<li key={`medida-${rota.path}`} className="menu-medida" aria-hidden="true">
							<span>
								<i className={`fa ${rota.icon}`}>
									<span className="menu-title bold">{rota.nome}</span>
								</i>
							</span>
						</li>
					))}
					{busca && resultado.length === 0 && (
						<li className="menu-busca-vazio" role="status">Nenhum menu encontrado</li>
					)}
					{/* Sair não é resultado de busca: some enquanto há texto no campo */}
					{!busca && (
						<li className="menu-home">
							<a onClick={fazerLogout} href="/">
								<i className="fa fa-sign-out">
									<span className="menu-title font-arial bold">Sair</span>
								</i>
							</a>
						</li>
					)}
				</ul>
			</div>
		</div>
	);
}

export default BarraLateral;
